import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class Footer extends Component{

    render() {
        var d = new Date();
        const currentYear = d.getFullYear();
        return(
            <footer
            id="footer"
            className="ct-section eds-on-scroll eds-scroll-visible fadeIn animated duration3"
          >
            <div className="ct-section-inner-wrap">
              <div id="div_block-30-7" className="ct-div-block footer-grid">
                <div id="div_block-31-7" className="ct-div-block footer-grid-left">
                  <img
                    id="image-32-7"
                    alt=""
                    src="checkout_files/logo.png"
                    className="ct-image"
                  />
                  <div id="div_block-33-7" className="ct-div-block">
                    <h5 id="headline-35-7" className="ct-headline footer-heading">
                      EditMyPaper.ca
                    </h5>
                    <div id="-pro-menu-37-7" className="oxy-pro-menu ">
                      <div className="oxy-pro-menu-mobile-open-icon ">
                        <svg id="-pro-menu-37-7-open-icon">
                          <use href="#FontAwesomeicon-ellipsis-v"></use>
                        </svg>
                        Menu
                      </div>
      
                      <div
                        className="oxy-pro-menu-container oxy-pro-menu-dropdown-links-visible-on-mobile oxy-pro-menu-dropdown-links-toggle oxy-pro-menu-show-dropdown oxy-pro-menu-init"
                        data-aos-duration="400"
                        data-oxy-pro-menu-dropdown-animation="fade-up"
                        data-oxy-pro-menu-dropdown-animation-duration="0.4"
                        data-entire-parent-toggles-dropdown="true"
                        data-oxy-pro-menu-dropdown-links-on-mobile="toggle"
                      >
                        <div className="menu-editmypaper-container">
                          <ul id="menu-editmypaper" className="oxy-pro-menu-list">
                            <li id="menu-item-493-de" className="footer-lang-item lang-item lang-item-133 lang-item-de lang-item-first menu-item menu-item-type-custom menu-item-object-custom menu-item-493-de">
                              <a href="https://editmypaper.ca/de/" hrefLang="de-DE" lang="de-DE">
                              <img src="images/footer/de_icon.png" alt="Deutsch" width="16" height="11"></img>
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li id="menu-item-493-ar" className="footer-lang-item lang-item lang-item-137 lang-item-ar menu-item menu-item-type-custom menu-item-object-custom menu-item-493-ar">
                              <a href="https://editmypaper.ca/ar/" hrefLang="ar" lang="ar">
                                <img src="images/footer/ar_icon.png"  alt="العربية" width="16" height="11" />
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li id="menu-item-493-zh" className="footer-lang-item lang-item lang-item-142 lang-item-zh menu-item menu-item-type-custom menu-item-object-custom menu-item-493-zh">
                              <a href="https://editmypaper.ca/zh/" hrefLang="zh-CN" lang="zh-CN">
                                <img src="images/footer/zh_icon.png" alt="中文 (中国)" width="16" height="11" />
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-18"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-18"
                            >
                              <a href="https://editmypaper.ca/our-editors">
                                Our Editors
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-19"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-19"
                            >
                              <a href="https://editmypaper.ca/blog/">
                                Our Blog
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-21"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-21"
                            >
                              <a href="https://editmypaper.ca/accessibility-statement">
                                Accessibility Statement
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-22"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-22"
                            >
                              <a href="https://editmypaper.ca/faq/">
                                FAQ
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-22"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-22"
                            >
                              <a href="https://editmypaper.ca/guarantee/">
                                Guarantee
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-23"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-23"
                            >
                              <a href="https://editmypaper.ca/privacy/">
                                Privacy Policy
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-22"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-22"
                            >
                              <a href="https://editmypaper.ca/tos/">
                                Terms of Service
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="oxy-pro-menu-mobile-close-icon">
                          <svg id="svg--pro-menu-37-7">
                            <use href="#FontAwesomeicon-close"></use>
                          </svg>
                          close
                        </div>
                      </div>
                    </div>
                  </div>
                  <div id="div_block-38-7" className="ct-div-block">
                    <h5 id="headline-39-7" className="ct-headline footer-heading">
                      What can we edit for you?
                    </h5>
                    <div id="-pro-menu-40-7" className="oxy-pro-menu ">
                      <div className="oxy-pro-menu-mobile-open-icon ">
                        <svg id="-pro-menu-40-7-open-icon">
                          <use href="#FontAwesomeicon-ellipsis-v"></use>
                        </svg>
                        Menu
                      </div>
      
                      <div
                        className="oxy-pro-menu-container oxy-pro-menu-dropdown-links-visible-on-mobile oxy-pro-menu-dropdown-links-toggle oxy-pro-menu-show-dropdown oxy-pro-menu-init"
                        data-aos-duration="400"
                        data-oxy-pro-menu-dropdown-animation="fade-up"
                        data-oxy-pro-menu-dropdown-animation-duration="0.4"
                        data-entire-parent-toggles-dropdown="true"
                        data-oxy-pro-menu-dropdown-links-on-mobile="toggle"
                      >
                        <div className="menu-what-can-we-edit-for-you-container">
                          <ul
                            id="menu-what-can-we-edit-for-you"
                            className="oxy-pro-menu-list"
                          >
                            <li
                              id="menu-item-24"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-24"
                            >
                              <a href="https://editmypaper.ca/paper-editing-service/">
                                Academic Journals
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-25"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-25"
                            >
                              <a href="https://editmypaper.ca/essay-editing-service/">
                                Academic Essays
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-26"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-26"
                            >
                              <a href="https://editmypaper.ca/paper-editing-service/">
                                Research Papers
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-27"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-27"
                            >
                              <a href="https://editmypaper.ca/essay-editing-service/">
                                Homework Assignments
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-28"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-28"
                            >
                              <a href="https://editmypaper.ca/dissertation-editing-service/">
                                Dissertations
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-29"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-29"
                            >
                              <a href="https://editmypaper.ca/thesis-editing-service/">
                                Thesis
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-29"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-29"
                            >
                              <a href="https://editmypaper.ca/citation-editing-service/">
                                Citation Editing Service
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                            <li
                              id="menu-item-29"
                              className="menu-item menu-item-type-custom menu-item-object-custom menu-item-29"
                            >
                              <a href="https://editmypaper.ca/personal-statement-editing/">
                              Personal Statement Editing
                                <div className="oxy-pro-menu-dropdown-icon-click-area"></div>
                              </a>
                            </li>
                          </ul>
                        </div>
                        <div className="oxy-pro-menu-mobile-close-icon">
                          <svg id="svg--pro-menu-40-7">
                            <use href="#FontAwesomeicon-close"></use>
                          </svg>
                          close
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div id="div_block-42-7" className="ct-div-block">
                  <h5 id="headline-43-7" className="ct-headline footer-heading">
                    Contact Us
                  </h5>
                  <a
                    id="link-48-7"
                    className="ct-link link-with-icon"
                    href="mailto:info@editmypaper.ca"
                    target="_self"
                  >
                    <img
                      id="image-49-7"
                      alt=""
                      src="index_files/footer/massage.png"
                      className="ct-image icon"
                    />
                    <div id="text_block-50-7" className="ct-text-block">
                      info@editmypaper.ca
                      <br />
                    </div>
                  </a>
                  <div id="code_block-943-7" className="ct-code-block">
                    <a
                      id="link-19-7"
                      href="javascript:void(Tawk_API.toggle())"
                      className="ct-link link-with-icon font-700"
                    >
                      <img
                        id="image-20-7"
                        alt=""
                        src="index_files/footer/chat.png"
                        className="ct-image icon"
                      />
                      <div id="text_block-21-7" className="ct-text-block">
                        Start Live Chat
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div id="div_block-56-7" className="ct-div-block divider"></div>
              <div id="div_block-57-7" className="ct-div-block">
                <div id="text_block-59-7" className="ct-text-block">
                  Copyright © {new Date().getFullYear()} Edit My Paper | All rights reserved
                </div>
                <img
                  id="image-58-7"
                  alt=""
                  src="index_files/footer/payment-methods.png"
                  className="ct-image"
                />
              </div>
            </div>
          </footer>
      
        )
    }
}

export default connect(
)(Footer);



// WEBPACK FOOTER //
// ./src/components/pages/Footer.js